import { writable } from 'svelte/store';
import { idb } from '../db.js';

const initProducts = () => {
    const { subscribe, set, update } = writable();

    const helpers = {
        init: async ( categoryUid ) => {
            if ( categoryUid == 'all'){
                set(await idb.getAll( 'pc_products'));
            }else{
                set(await idb.getAllFromIndex.eq( 'pc_products', 'category', categoryUid));
            }
        },
        add: ( data ) => { 
            console.group(`INFO: products.add`);console.log(data);
            update( current => {
                let next = current.concat(data);
                console.log(`next`); console.log(next);
                idb.save( 'pc_products', next);
                return next;
            });
            console.groupEnd();
        }
    }
    return {
        subscribe,
        set,
        update,
        ...helpers
    }
};

export const productsIDB = initProducts();